import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
/*
 * @Author: 李才人
 * @Date: 2021-08-05 11:36:40
 * @LastEditors: 李才人
 * @LastEditTime: 2021-08-05 12:01:23
 * @FilePath: \m_saas_business_admin\src\store\index.ts
 * @Description:
 */
import instance from "./instance";
/**加载同级目录下的module里的所有脚本 */
const modulesFiles = require.context("./modules", true, /\.ts$/);
modulesFiles.keys().forEach(modulePath => {
  modulesFiles(modulePath);
});
/** 实现自动加载@modules 下的模块里的router文件夹里的文件 ：要求模块名不能与/store/modules下的文件名重复*/
const serviceModulesFiles = require.context("../modules", true, /\.\/[a-zA-Z0-9_-]+\/store\/.+\.ts$/);
serviceModulesFiles.keys().forEach(modulePath => {
  serviceModulesFiles(modulePath);
});
export default instance;